import { Separator } from '@radix-ui/react-dropdown-menu';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './dropdown.scss';

type Props = ComponentPropsWithoutRef<typeof Separator>;
export const DropdownSeparator = ({ className, ...props }: Props) => {
    return (
        <Separator
            data-testid="dropdown-menu-separator"
            className={cn('dropdown__separator', className)}
            {...props}
        />
    );
};
